import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface HorizontalCarouselProps {
  images: string[];
  interval?: number;
}
export function HorizontalCarousel({
  images,
  interval = 3000
}: HorizontalCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const goToNext = useCallback(() => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % images.length);
  }, [images.length]);
  useEffect(() => {
    // Defer interval to reduce TBT
    const timer = setTimeout(() => {
      const intervalId = setInterval(goToNext, interval);
      return () => clearInterval(intervalId);
    }, 3000);
    return () => clearTimeout(timer);
  }, [goToNext, interval]);
  const goToSlide = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? '20%' : '-20%',
      scale: 0.9,
      opacity: 0
    }),
    center: {
      x: 0,
      scale: 1,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? '-20%' : '20%',
      scale: 0.9,
      opacity: 0
    })
  };
  return <div className="relative w-full max-w-sm mx-auto" data-id="element-15">
      {/* Card Container */}
      <div className="relative aspect-[3/4] overflow-hidden rounded-2xl shadow-2xl bg-gray-800" data-id="element-16">
        <AnimatePresence mode="wait" custom={direction} data-id="element-17">
          <motion.img key={currentIndex} src={images[currentIndex]} alt={`Estudiante con manual ${currentIndex + 1}`} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
          type: 'spring',
          stiffness: 100,
          damping: 20,
          mass: 1
        }} className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-18" />
        </AnimatePresence>

        {/* Subtle bottom gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" data-id="element-19" />
      </div>

      {/* Navigation Dots */}
      <div className="flex justify-center gap-2 mt-4" data-id="element-20">
        {images.map((_, i) => <button key={i} onClick={() => goToSlide(i)} className={`rounded-full transition-all duration-300 ${i === currentIndex ? 'w-6 h-2 bg-yellow-400' : 'w-2 h-2 bg-white/30 hover:bg-white/50'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-21" />)}
      </div>
    </div>;
}